import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a5bed51"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "subMenu"
}
const _hoisted_2 = {
  key: 2,
  class: "subMenu"
}
const _hoisted_3 = {
  key: 1,
  class: "redeem"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "giftIcon" }, null, -1))

import HeaderMenu from "./Header.vue";
import FooterLayout from "./Footer.vue";
import HelpMenus from "./SubMenusHelp.vue";
import BookMenus from "./SubMenusBook.vue";
import UserCenterMenus from "./SubMenusUserCenter.vue";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import store from "@/store";
import { useStore } from "vuex";
import { destroyDriver } from "@/utils/driver";
import NewUserDialog from "@/views/ActivePage/ActiveDialog/NewUserDialog.vue";
import { isGotoLogin } from "@/utils/index";
// 判断是否为新手引导状态

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const driverState = computed(() => !!store.getters.getDriverState);

// 跳过新手引导
const skipBoot = () => {
  destroyDriver(false);
};
// 联系我们
const contactUs = () => {
  if (driverState.value) {
    return;
  } else {
    (window as any).easemobim.bind();
  }
};
const appLanguage = computed(() => useStore().state.appLanguage);

const route = useRoute();
const isShowHelpMenus = computed(() => route.meta.mainMenuPosition === "help");
const isMobile = computed(() => !!store.state.isMobile);
const isShowBookMenus = computed(
  () => route.meta.mainMenuPosition === "helpBooks"
);
const MobileHiddenFooterRouters = [
  "login",
  "register",
  "mobilePay",
  "gift",
  "userCenter",
];
const isShowFooter = computed(() => {
  return (
    !store.state.isMobile ||
    !MobileHiddenFooterRouters.includes(route.meta.mainMenuPosition as string)
  );
});
const isShowUserCenterMenus = computed(
  () => route.meta.mainMenuPosition === "userCenter"
);

const router = useRouter();
const goDedeem = () => {
  if (!isGotoLogin()) {
    router.push({
      path: "/pointsMall",
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'layout-mobile': _unref(isMobile) })
    }, [
      _createVNode(HeaderMenu),
      (_unref(isShowHelpMenus))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['subMenu', { mobileSize: _unref(isMobile) }])
          }, [
            _createVNode(HelpMenus),
            _createVNode(_component_router_view)
          ], 2))
        : (_unref(isShowBookMenus))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(BookMenus),
              _createVNode(_component_router_view)
            ]))
          : (_unref(isShowUserCenterMenus))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (!_unref(isMobile))
                  ? (_openBlock(), _createBlock(UserCenterMenus, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_view)
              ]))
            : (_openBlock(), _createBlock(_component_router_view, { key: 3 })),
      (_unref(isShowFooter))
        ? (_openBlock(), _createBlock(FooterLayout, { key: 4 }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["rightIcons", _unref(driverState) ? 'callMeflex' : 'callMeFixed']),
      style: _normalizeStyle(_unref(appLanguage) == 'en' && _unref(driverState) ? 'margin-top: -265px' : '')
    }, [
      (!_unref(isMobile))
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "customerBtn",
            href: "javascript:void(0);",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (contactUs()))
          }))
        : _createCommentVNode("", true)
    ], 6),
    (_unref(driverState))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "skipBtn",
          onClick: skipBoot
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("novice_guidance.step_btn_skip")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goDedeem()))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("active_page.redeem")), 1),
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(NewUserDialog)
  ], 64))
}
}

})